<div class="pag-container">

    <!-- Breadcrumb -->

    <app-campaign-3-breadcrumb #breadcrumbComponent [arrayBreadcrumbs]="breadcrumbs"
    (onClickBreadcrumb)="breadcrumbClicked($event)" homeLink=""></app-campaign-3-breadcrumb>

    <div *ngIf="infoAction" class="ui-g-12 mt4">
        <div class="info-action">
            <span>{{ 'campaign.select_time_interval' | translate }}</span>
        </div>
    </div>
    <div class="ui-g-12 d-flex justify-content-center">

        <div class="ui-g-7">
        </div>
        <div class="ui-g-5 footer-btn-container">

            <button class="btn-page-act btn-footer-l" (click)="onCampaignTable()">
                <i class="pi pi-eye"></i> <span>{{ 'campaign.view_campaign_list' | translate }}</span>
            </button>
            <button class="btn-page-act" (click)="onOpenCreation()">
                <i class="pi pi-plus"></i> <span>{{ 'campaign.create_new_campaign' | translate }}</span>
            </button>
        </div>
    </div>

    <!-- Date Selection -->

    <div class="ui-g-12">

        <div class="ui-g-6 " style="margin-top: 20px;">
            <div class="ui-g-8  d-flex align-items-center">
                <span class="title">{{ 'campaign.action_list' | translate }}</span>
            </div>
            <div class="ui-g-4 d-flex align-items-center">
                <span class="title-span">{{ 'campaign.select_interval' | translate }}</span>
            </div>
        </div>

        <div class="ui-g-3">
            <span class="date-range">{{ 'campaign.from' | translate }}</span>
            <br>
            <p-calendar [(ngModel)]="startDate" dateFormat="dd/mm/yy" [showIcon]="true"></p-calendar>
        </div>
        <div class="ui-g-3">
            <span class="date-range">{{ 'campaign.to' | translate }}</span>
            <br>
            <p-calendar [(ngModel)]="endDate" dateFormat="dd/mm/yy" [showIcon]="true"></p-calendar>
        </div>
    </div>

    <!-- Kontable-3 -->

    <div class="ui-g-12">
        <app-campaign-3-kontable #actionlist *ngIf="readyTable" [columns]="[

        { field: 'name', title: 'campaign.name', filterType: textFilter, bodyTemplate: nameTemplate },
        { field: 'start_emission_date', title: 'campaign.start_emission_date', filterType: noFilter, bodyTemplate: startDateTemplate },
        { field: 'end_fruition_date', title: 'campaign.end_fruition_date', filterType: noFilter, bodyTemplate: endDateTemplate },
        { field: 'campaign_name', title: 'campaign.campaign_name', filterType: textFilter },
        { field: 'action_type', title: 'campaign.action_type', filterType: selectFilter, filterOptions: { values: actionTypes } },
        { field: 'actual_generated_coupon', title: 'campaign.actual_generated_coupon', filterType: noFilter, bodyTemplate: couponTemplate },
        { field: 'code', title: 'campaign.code', filterType: textFilter },
        { field: 'status_id', title: 'campaign.campaign_status_id', filterType: selectFilter, filterOptions: { values: actionStatusList }, bodyTemplate: statusTemplate }


    ]" [service]="testService" [paginationType]="paginationType" [showRecoverButton]="false" [showInfoButton]="false"
            [showAddButton]="false" [showDeleteButton]="false" [showDetailsButton]="false" [showEditButton]="false"
            [filterBySingleColumn]="false" [additionalRowCommands]="actions" [showGlobalFilter]="true"
            [expandTable]="false" [subjectToLoad]="pageSubject" [filterStartDate]="startDate"
            [filterEndDate]="endDate"  (onClearFilters)="clearDateFields()"
            [methodsNames]="{ list: 'listActions', sendExtSearchQuery: 'sendExtSearchQuery' }">


            <ng-template #startDateTemplate let-row>
                <span>{{ row.start_emission_date | date:srvCalendar.pcalendarTranslate.dateFormatFilter }}</span>
            </ng-template>

            <ng-template #endDateTemplate let-row>
                <span>{{ row.end_fruition_date| date:srvCalendar.pcalendarTranslate.dateFormatFilter }}</span>
            </ng-template>


            <ng-template #statusTemplate let-row>

                <button class="status-button" [style.background-color]="row.color" >
                    {{row.status}}
                </button>
            </ng-template>


            <ng-template #nameTemplate let-row>
                <span> {{row.name}}</span>
            </ng-template>


            <ng-template #couponTemplate  let-row>
                <span>{{row.actual_generated_coupon}}</span>
            </ng-template>

            <ng-template #actions let-row>

                <div class="detail-btn-container">
                    <button class="btn-details" (click)="onOpenInfoAction(row.id)">
                        <i class="pi pi-eye margin-fit"></i>
                    </button>
                    <div class="d-flex flex-row">
                        <button class="btn-details" (click)="toggleMenu(row.id)">
                            <i class="pi pi-ellipsis-h margin-fit"></i>
                        </button>
                        <div class="dropdown-menu" *ngIf="showMenu && row.id == currentOpenedRow">

                            <button class="dropdown-item-creation" (click)="editAction(row)">{{checkOnlyRead(row)}}</button>
                            <button class="dropdown-item-creation" (click)="showCoupons(row.id)" >{{ 'campaign.generated_coupons' | translate }}</button>
                           <!--  <button class="dropdown-item-creation" (click)="onDeleteAction(row)">Elimina Azione</button> -->


                           <button class="dropdown-item-creation" (click)="onDeleteAction(row, i)" [disabled]="row.status == 'Pubblicata'" [ngClass]="{'disabled-button': row.status == 'Pubblicata'}">
                            {{ 'campaign.delete_action' | translate }}
                        </button>

                        </div>
                    </div>
                </div>

            </ng-template>
        </app-campaign-3-kontable>

    </div>
</div>
<div *ngIf="showPopupInfo">
    <p-dialog class="myDialog" header="{{ 'campaign.summary_actions' | translate }}" [(visible)]="showPopupInfo" [modal]="true">
       
        <app-info-action-3 [acmNoBurned]="acmNoBurned"
            (closeInfoPopup)="onClosePopupInfo()" [action]="singleAction"></app-info-action-3>
    </p-dialog>
</div>

<!-- popup creazione campagna visibile solo dopo la pressione del relativo bottone -->
<div *ngIf="showPopupCreate">
    <p-dialog class="myDialog" header="{{ 'campaign.create_campaign' | translate }}" [(visible)]="showPopupCreate" [modal]="true">
        <app-new-campaign-3  [budgetTypeList]="budgetList" [campaignTypeList]="campaignType" [statusList]="statusList"></app-new-campaign-3>
    </p-dialog>
</div>



<p-dialog
  header="{{ 'campaign.confirm_delete' | translate }}"
  [(visible)]="displayDeleteDialog"
  [modal]="true"modal="modal"
  [closable]="false"
  class="custom-dialog">

  <div>{{ 'campaign.confirm_delete_action' | translate }} {{ actionToDelete?.description }}?</div>

  <div class="custom-footer">
    <button type="button" pButton label="{{ 'common.cancel' | translate}}" (click)="closePopupDelete()" icon="pi pi-times"></button>
    <button type="button" pButton label="{{ 'common.confirm' | translate}}"
    (click)="onDefinitiveDelete(actionToDelete)" icon="pi pi-check" style="margin-left: .25em"></button>
  </div>
</p-dialog>



<footer>

</footer>



// WEBPACK FOOTER //
// ./src/app/views/campaign-3/action-list-3/action-list-3.component.html